import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

const CursoCard = ({ curso, onComprar, onAcessar, isMatriculado }) => {
  if (!curso) return null;

  return (
    <Card className="flex flex-col h-full overflow-hidden hover:shadow-lg transition-shadow">
      <div className="h-48 bg-slate-200 overflow-hidden relative">
        {curso.capa_url ? (
          <img src={curso.capa_url} alt={curso.titulo} className="object-cover w-full h-full" />
        ) : (
          <div className="flex items-center justify-center h-full text-slate-400 font-medium">Sem Capa</div>
        )}
      </div>
      <CardHeader>
        <div className="flex justify-between items-start mb-2">
          <Badge variant="outline">{curso.categoria || 'Geral'}</Badge>
          <Badge className={curso.nivel === 'avancado' ? 'bg-red-500' : 'bg-blue-500'}>{curso.nivel || 'Básico'}</Badge>
        </div>
        <CardTitle className="text-xl line-clamp-2">{curso.titulo}</CardTitle>
      </CardHeader>
      <CardContent className="flex-1">
        <p className="text-sm text-slate-600 line-clamp-3">{curso.descricao}</p>
        <div className="mt-4 font-bold text-lg">
          {curso.preco > 0 ? `R$ ${curso.preco}` : 'Gratuito'}
        </div>
      </CardContent>
      <CardFooter>
        {isMatriculado ? (
          <Button onClick={onAcessar} className="w-full">Acessar Curso</Button>
        ) : (
          <Button onClick={onComprar} variant="default" className="w-full">Matricular</Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default CursoCard;